import { DEVICE_ROUTES, } from "@repo/contract/notifications";
import { sendNoContent } from "../core/request";
/**
 * `POST`/`DELETE /me/devices` (`D89`, `D94`) — the FCM token handed to, and
 * taken back from, the Worker. Both answer `204` and both are idempotent:
 * registering a known token refreshes it, deleting an unknown one succeeds.
 *
 * Plain functions, no query and no mutation: registration is not a screen's
 * write but a step of `apps/mobile/src/native/push.ts`'s ordered sequence
 * (channels, then permission, then token). T68 passes these in there; this
 * module does not change `push.ts`.
 *
 * `input.token` is the NATIVE FCM registration token string, never the object
 * a plugin wraps it in (`registerDeviceInput` says why).
 */
export function registerDevice(api, input) {
    return sendNoContent(api, "POST", DEVICE_ROUTES.devices, input);
}
export function unregisterDevice(api, input) {
    return sendNoContent(api, "DELETE", DEVICE_ROUTES.devices, input);
}
//# sourceMappingURL=devices.js.map